import { render, staticRenderFns } from "./soroteca-armazenar.vue?vue&type=template&id=a21272b4&scoped=true&"
import script from "./soroteca-armazenar.vue?vue&type=script&lang=js&"
export * from "./soroteca-armazenar.vue?vue&type=script&lang=js&"
import style0 from "./soroteca-armazenar.vue?vue&type=style&index=0&id=a21272b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21272b4",
  null
  
)

export default component.exports